import actions from './actions';

const module = {
  actions,
};

export default module;
